import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';
import AlertMessageBase, { IconType } from 'components/Generic/AlertMessageBase';

type Fields = {
  alertTitle: Field<string>;
  alertText: Field<string>;
  expandedView: Field<boolean>;
  alertExpandableText: Field<string>;
};

type AlertMessageProps = ComponentProps & {
  fields: Fields;
  rendering: object;
};

const AlertMessage = ({ fields, rendering }: AlertMessageProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const alertType: IconType | undefined = rendering.params?.alertType?.toLowerCase() as IconType;

  return (
    <div id={anchorId} className="container d-flex justify-content-center mb-8">
      <div className="col-11 alert-message">
        <AlertMessageBase
          type={alertType}
          title={fields.alertTitle.value}
          description={fields.alertText}
          expandableDescription={fields.alertExpandableText}
          defaultExpanded={fields.expandedView.value}
        />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<AlertMessageProps>(AlertMessage);
